<template lang="pug">
#content.content.background
  .container
    .row
      .col-md-12
        div.box_step
          .item-step(v-bind:class="[step === 1  || step === 2 ? 'active': '']")
            span 1
          span.horizontal-line
          .item-step(v-bind:class="[step === 2 ? 'active': '']")
            span 2
          .clearfix
        div.box-content
          .box-pc-step(v-bind:class="[step === 1 ? 'open' : '']")
            .item-pc-title TẠO PC MỚI
            .item-pc-content
              .form-group(v-bind:class="[isSubmitStep && (key_pc_name.length === 0 || key_pc_exists || (key_pc_name.length > 0 && isCharactorPC)) ? 'error' : '']")
                span.characters(v-text="key_pc_name.length +'/' + maxCharacters")
                label.control-label Nhập tên PC
                input.form-control( name="key_pc_name" maxlength = 125 placeholder="Nhập" :maxlength="maxCharacters" autofocus v-model.trim="key_pc_name")
                span.required(v-if="isSubmitStep && key_pc_name.length === 0") Vui lòng nhập tên PC
                span.required(v-if="isSubmitStep && key_pc_name.length > 0 && isCharactorPC") Tên PC không được nhập ký tự đặc biệt như !@#$%^&*()/\{}?`|[]
                span.required(v-if="isSubmitStep && key_pc_exists") Tên PC đã tồn tại
              .form-group(v-bind:class="[isSubmitStep && (key_pc_subjects.length === 0 || key_pc_subjects === 0) ? 'error' : '']")
                label.control-label Môn học
                select.form-control(name="key_pc_subjects" v-model.trim="key_pc_subjects")
                  option(disabled value='0' :selected="key_pc_subjects === 0") Chọn môn học
                  option(v-for='o in subjects' v-bind:value='o.id' :selected="key_pc_subjects === o.id" v-if="!lstAllPCs.includes(o.id)") {{o.name}}
                span.required Vui lòng chọn môn học bạn muốn tạo PC
              .form-group(v-bind:class="[isSubmitStep && (key_pc_id.length === 0 || siteExists > 0  || isCharactor)? 'error' : '']")
                label.control-label ID của trang
                input.form-control(maxlength = 125 name="key_pc_id" placeholder="Example"  v-model.trim="key_pc_id" autocomplete="off")
                span.required(v-if="key_pc_id.length === 0") Vui lòng nhập ID trang tối đa 125 ký tự
                span.required(v-if="key_pc_id.length > 0 && isCharactor") ID trang chỉ chứa các ký tự a-z và 0-9 hoặc dấu .-+_ 
                span.required(v-if="key_pc_id.length > 0 && siteExists > 0") ID trang đã tồn tại trong hệ thống
              .note
                span ID trang sau khi tạo sẽ không được chỉnh sửa. Trang của bạn sẽ được hiển thị như sau: 
                span.link 
                  strong.domain {{domain}}
                  b.text(v-if="key_pc_id.length") {{key_pc_id}}/
            .item-pc-bottom
              .form-group
                button.active(@click="next()") Thêm yêu cầu mới
                router-link.button(to="/general") Huỷ yêu cầu
          .box-pc-step(v-bind:class="[step === 2 ? 'open' : '']")
            .item-pc-title Nội dung hiển thị
            .item-pc-content
              .form-group(v-bind:class="[isSubmitFinish && ($mycontroller.stripHtml(key_pc_content).length === 0 || isMaxAllow || isMinAllow)? 'error' : '']")
                span.characters.italic(v-text="numberWithCommas($mycontroller.stripHtml(key_pc_content).length) +'/' + numberWithCommas(maxCharactersContent) + ' ký tự'")
                label.control-label Giới thiệu ngắn về cộng đồng của bạn
                froala#editor(:tag="'textarea'" :config="config" v-model.trim="key_pc_content" autofocus @input="changeContent")
                span.required(v-if="isMaxAllow") Vui lòng nhập tối đa 1000 ký tự
                span.required(v-if="isMinAllow") Nhập tối thiểu 100 ký tự
              .form-group(v-bind:class="[isSubmitFinish && lstIcons.length === 0 ? 'error' : '']")
                .box-icon
                  label.control-label
                    strong Icon cộng đồng: 
                      span (Kích thước đề nghị: 300x300 px)
                  #list_icon
                    .box-button
                      .item-button
                        input(id="icon" name="icon" type="file" accept="image/*" @change="onIconChange")
                        span Tải ảnh lên
                      .item-button
                        span(@click="openLibrary") Chọn từ thư viện
                    .box-item-icon
                      .box-item(v-if="icon" v-for="(icon, index) in lstIcons")
                        span.material-icons.remove(@click='deleteIcon(index)') cancel
                        img.img-responsive(:src="icon.src")
                      span.required Vui lòng upload ảnh icon cộng đồng của bạn
                      .clearfix
                    .clearfix
              .form-group(v-bind:class="[isSubmitFinish && (lstBanners.length === 0 || lstBanners.length > 5) ? 'error' : '']")
                .box-images
                  label.control-label
                    strong Ảnh banner của cộng đồng: 
                      span (Kích thước đề nghị: 1600x900 px)
                  #list_banner
                    .box-item(v-if="banner" v-for="(banner, index) in lstBanners")
                      span.material-icons.remove(@click='deleteBanner(index)') cancel
                      img.img-responsive(:src="banner.src")
                    .box-item.last 
                      input(id="banner" name="banner" type="file" accept="image/*" multiple @change="onImageChange")
                      span 
                          i.material-icons.list-action add
                          strong Tải ảnh lên
                    .clearfix      
                    span.required(v-if="lstBanners.length === 0") Vui lòng upload ảnh banner cộng đồng của bạn
                    span.required(v-if="lstBanners.length > 0 && lstBanners.length > 5") Vui lòng upload ảnh tối đa 5 ảnh
                  .clearfix  
            .item-pc-bottom
              .form-group
                button.active(@click="finishPC()") Hoàn thành
                button(@click="prev()") Quay lại
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import mdPopup from '../PC/popup'
import S3FileUpload from '../S3FileUpload/S3FileUpload.js'
import MdNotification from '@/core/components/mdNotification'
export default {
  components: {
    MdNotification,
    S3FileUpload
  },
  data() {
    return {
      fullPage: true,
      message: this.$t('home.comming_soon'),
      step: 1,
      isCharactor: false,
      isCharactorPC: false,
      siteExists: 0,
      maxCharacters: 125,
      maxCharactersContent: 1000,
      key_pc_name: '',
      key_pc_content: '',
      key_pc_id: '',
      domain: window.location.host + '/' + this.$router.resolve({path: '/'}).href + 'landing/',
      subjects: [],
      key_pc_subjects: 0,
      lstBanners: [],
      lstIcons: [],
      lstAllPCs: [],
      banners: [],
      icons: [],
      isSubmitStep: false,
      isSubmitFinish: false,
      isMaxCreated: false,
      isMaxAllow: false,
      isMinAllow: true,
      key_pc_exists: false,
      loader: null,
      config: {
        heightMin: 300,
        autofocus: true,
        placeholderText: 'Nhập ...',
        // entities: '&nbsp;&quot;&#39;&iexcl;&cent;&pound;&curren;&yen;&brvbar;',
        key: 'jUA1yD5B4D1C1F2D1pZGCTRSAPJWTLPLZHTQQb1JGZxE2F2G2B1B10B2A3E6D1G2==',
        charCounterMax: 1000,
        htmlUntouched: true,
        events: {
          'initialized': function () {
            console.log('initialized')
          },
          'charCounter.exceeded': function () {
            console.log(this)
          }
        }
      }
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    isAllow: function(evt) {
      evt = (!evt) ? window.event : evt
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode < 97 || charCode > 122) && (charCode < 48 || charCode > 57) && charCode !== 95 && charCode !== 45 && charCode !== 43) {
        evt.preventDefault()
      }
      return true
    },
    checkIDPage() {
      var regexConst = new RegExp(/[^0-9a-z-._(+)]/g)
      return regexConst.test(this.key_pc_id)
    },
    checkPCNameAllowCharacter() {
      var regexConst = new RegExp(/[!@#$%^&*()/\\{}?`|[\]]/g)
      return regexConst.test(this.key_pc_name)
    },
    prev() {
      this.step--
    },
    changeContent($event) {
      this.isMinAllow = true
      this.isMaxAllow = false
      var text = this.$mycontroller.stripHtml($event)
      this.isMinAllow = text.length < 100
      this.isMaxAllow = text.length > 1000
    },
    async checkTypeTeacher() {
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_PC_OF_USER),
        variables: {
          where: {
            user_id: {_eq: this.$store.getters.user}
          }
        }
      })
      var dataPC = data.private_community
      if (dataPC.length > 0 && !isNaN(this.key_pc_subjects) && Number(this.key_pc_subjects) > 0) {
        // kiem tra da tao mon hoc nay chua
        var returnData = dataPC.filter(obj => obj.subject_id === this.key_pc_subjects)
        if (returnData && returnData.length > 0) {
          this.isMaxCreated = true
          this.showNotification('Bạn không thể tạo thêm cộng đồng vì các môn học có thể giảng dạy đều đã có cộng đồng riêng', 'warning', 'top', 'right', 2000)
          this.loader.hide()
        }
        // check so luon pc toi da theo type user
        // else if (dataPC.length > 1 && this.$store.getters.fullname.type_user === 2) {
        //   this.isMaxCreated = true
        //   this.showNotification('Đã quá số lượng cộng đồng cho phép. Nâng cấp tài khoản lên gói premium ngay để tạo thêm cộng đồng mới', 'warning', 'top', 'right', 2000)
        //   this.loader.hide()
        // }
      }
    },
    next() {
      this.isSubmitStep = true
      this.isCharactorPC = false
      this.isCharactor = this.checkIDPage()
      this.isCharactorPC = this.checkPCNameAllowCharacter()
      if (this.isSubmitStep && this.key_pc_name.length > 0 && this.key_pc_subjects > 0 && this.key_pc_id.length > 0 && !this.isCharactor && !this.isCharactorPC) {
        if (this.siteExists === 0) this.checkSiteID()
        if (!this.key_pc_exists) this.checkPCName()
      }
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    async checkSiteID() {
      this.show()
      await this.$apollo.query({
        query: gql(graphql.GET_PC_OF_USER),
        variables: {
          where: {
            site_id: {_eq: this.key_pc_id}
          }
        }
      }).then(response => {
        this.siteExists = response.data.private_community.length
      })
      this.checkPCName()
      if (this.isSubmitStep && this.key_pc_name.length > 0 && this.key_pc_subjects > 0 && this.key_pc_id.length > 0 && this.siteExists === 0 && !this.key_pc_exists) {
        this.loader.hide()
        this.step++
      } else this.loader.hide()
    },
    async checkPCName() {
      await this.$apollo.query({
        query: gql(graphql.GET_PC_OF_USER),
        variables: {
          where: {
            name: {_ilike: this.key_pc_name},
            status: {_eq: 1},
            user_id: {_eq: this.$store.getters.user}
          }
        }
      }).then(response => {
        this.key_pc_exists = response.data.private_community.length > 0
      })
    },
    openLibrary() {
      this.showNotification(this.message, 'warning', 'top', 'right', 2000)
    },
    deleteBanner: function (index) {
      this.lstBanners.splice(index, 1)
    },
    onImageChange(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      for (let i = 0; i < files.length; i++) {
        let obj = {'name': files[i].name, 'file': files[i], 'src': URL.createObjectURL(files[i])}
        this.lstBanners.push(obj)
      }
    },
    deleteIcon: function (index) {
      this.lstIcons.splice(index, 1)
    },
    onIconChange(e) {
      this.lstIcons = []
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      for (let i = 0; i < files.length; i++) {
        let obj = {'name': files[i].name, 'file': files[i], 'src': URL.createObjectURL(files[i])}
        this.lstIcons.push(obj)
      }
    },
    finishPC() {
      this.isSubmitFinish = true
      if (this.isSubmitFinish && this.key_pc_content.length > 0 && this.lstIcons.length > 0 && this.lstBanners.length > 0 && this.$store.getters.user !== '' && this.lstBanners.length < 6 && this.siteExists === 0 && !this.isCharactorPC && !this.isMinAllow && !this.isMaxAllow) {
        this.savePC()
      }
    },
    async savePC() {
      this.show()
      if (this.$store.getters.fullname.type_user === 2 || this.$store.getters.fullname.type_user === 3) {
        await this.checkPCName()
        if (!this.key_pc_exists) {
          await this.checkTypeTeacher()
          if (!this.isMaxCreated) {
            this.$apollo.mutate({
              mutation: gql(graphql.CREATE_PC),
              variables: {
                name: this.key_pc_name,
                user_id: this.$store.getters.user,
                description: this.key_pc_content,
                subject_id: this.key_pc_subjects,
                site_id: this.key_pc_id
              },
              update: (store, { data: { insert_private_community } }) => {
                if (insert_private_community.affected_rows) {
                  let returning = insert_private_community.returning[0]
                  this.updatePCUploadImg(returning.id)
                }
              }
            }).catch((error) => {
              this.loader.hide()
              this.showNotification(error, 'warning', 'top', 'right', 2000)
            })
          }
        }
      } else {
        this.showNotification('Bạn không có quyền tạo PC', 'warning', 'top', 'right', 2000)
        this.loader.hide()
      }
    },
    async updatePCUploadImg($id) {
      let directory = 'images/pc'
      let config = S3FileUpload.computed.config(directory)
      let S3Client = new S3FileUpload.computed.S3Client(config)

      if (this.lstIcons.length > 0) {
        for (let index = 0; index < this.lstIcons.length; index++) {
          let icon = this.lstIcons[index]
          let file = icon.file
          let fileName = icon.name.split('.')[0].replace(/ /g, '')
          let random = Math.random().toString().slice(2)
          let fieldName = `${random}_${fileName}`
          await S3Client.uploadFile(file, fieldName).then((data) => {
            this.icons.push(data.location)
          })
        }
      }
      if (this.lstBanners.length > 0) {
        for (let index = 0; index < this.lstBanners.length; index++) {
          let banner = this.lstBanners[index]
          let file = banner.file
          let fileName = banner.name.split('.')[0].replace(/ /g, '')
          let random = Math.random().toString().slice(2)
          let fieldName = `${random}_${fileName}`
          await S3Client.uploadFile(file, fieldName).then((data) => {
            this.banners.push(data.location)
          })
        }
      }

      this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_PC_IMG),
        variables: {
          id: $id,
          user_id: this.$store.getters.user,
          banner: '{' + this.banners.join() + '}',
          icon: this.icons.length > 1 ? '{' + this.icons.join() + '}' : this.icons[0]
        },
        update: (store, { data: { update_private_community } }) => {
          if (update_private_community.affected_rows) {
            this.loader.hide()
            this.showPopupSucess()
          }
        }
      })
    },
    showPopupSucess() {
      this.$modal.show(mdPopup, {pc_name: this.key_pc_name}, {
        clickToClose: false,
        height: 'auto',
        adaptive: true,
        classes: ['col-md-6'],
        reset: true
      })
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    async getAllPC () {
      let result = await this.$apollo.query({
        query: gql(graphql.GET_PC_OF_USER),
        fetchPolicy: 'no-cache',
        variables: {
          where: {
            user_id: {_eq: this.$store.getters.user},
            status: {_eq: 1}
          }
        }
      })
      if (result.data.private_community != null) {
        var lstPC = result.data.private_community
        for (let index = 0; index < lstPC.length; index++) {
          const element = lstPC[index]
          if (this.lstAllPCs.indexOf(element.subject_id) === -1) this.lstAllPCs.push(element.subject_id)
        }
      }
    }
  },
  async created() {
    await this.getAllPC()
  },
  beforeDestroy() {
  },
  apollo: {
    subjects: {
      query: gql(graphql.GET_SUBJECT_USER),
      fetchPolicy: 'no-cache',
      variables() {
        let variables = {
          where: {
            is_delete: {'_eq': false},
            user_id: {'_eq': this.$store.getters.user},
            status: {'_eq': 2}
          },
          orderBy: {created_at: 'asc'}
        }
        return variables
      },
      update: data => {
        if (data.subject_user.length > 0) {
          let lstSubjects = []
          for (let i = 0; i < data.subject_user.length; i++) {
            lstSubjects.push(data.subject_user[i].subject)
          }
          return lstSubjects
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  &.background {background: #FBF4D2 url('../../assets/images/login/bg_pattern.png') no-repeat center 150px; min-height: 100%;}
  .box_step{text-align: center; margin:  25px auto;
    .horizontal-line{position: relative;height: 1px;width: 100px;margin: 0 2px; top:-5px;  display: inline-block; background: #9F6A28;}
    .item-step{background: #FBF4D2 url('../../assets/images/pc/ic_step_off.svg') no-repeat;  position: relative; display: inline-block;width: 60px; height: 67px;
      &.active{background: #FBF4D2 url('../../assets/images/pc/ic_step_ON.svg') no-repeat;box-shadow: none;}
      span{display: block; line-height: 32px;text-align: center;font-size: 20px; font-weight: bold;font-family: 'Open Sans';letter-spacing: 0px;color: #4B2D15;position: relative; line-height: 67px;}
    }
  }
  .box-content{margin: 15px auto 25px auto;
      .lowercase{text-transform: lowercase;}
      .box-pc-step{margin: 0 auto; background: #FFFFFF 0% 0% no-repeat padding-box;box-shadow: 0px 1px 2px #00000029;border-radius: 3px; padding: 15px; width: 484px;display: none;
        &.open{display: block;}
        .item-pc-title{text-align: left; font-size: 17px; font-weight: bold; font-family: Helvetica;letter-spacing: 0px;color: #333;}
        .item-pc-content{
          .form-group{position: relative; margin-top: 10px; padding-bottom: 0;
            &.error{
              input, select{border: 1px solid #f00;color: #f00;}
              span.required{display: block; color: #f00; text-align: left;}
            }
            label{font-size: 12px;color: #343A40;margin-bottom: 5px;}
            span.characters{position: absolute; right: 0; font-weight: normal;font-size: 12px;
              &.italic{font-style: italic;}
            }
            span.required{display: none;}
            .box-images{margin: 0;
              strong{
                span{color:#969FAD !important;font-weight: normal !important; }
              }
              #list_banner{margin-top: 10px; 
                .box-item{float:left;width: 122px;height: 122px; margin-right:20px;margin-bottom:10px; position: relative; 
                  input{cursor: pointer;border-radius: 10px;}
                  img{max-width: 100%; height: auto; max-height: 100%; margin: 0 auto;}
                  span{position: absolute; right: 5px; top:5px;cursor: pointer;
                    &.remove{color: #f00;}
                  }
                  &.last{margin-right: 0 !important; background: #EAEAEA 0% 0% no-repeat padding-box;box-shadow: 0px 1px 2px #00000029;border: 1px solid #EAEAEA;border-radius: 3px;text-align:center;display:table-cell;vertical-align:middle;line-height:122px; cursor: pointer;
                    span{text-align:center; display: inline-block;vertical-align: middle;line-height: normal; position:relative; top: auto; right: auto;}
                    strong{display:block; text-align:center;color: #343A40; font-size:15px;font-weight: normal !important; }       
                  }
                }
              }
            } 
            .box-icon{
              label{
                strong{
                  span{color:#969FAD !important;font-weight: normal !important; }
                }
              }
              .box-item{float:left;width: 122px;height: 122px; margin-left:15px;margin-bottom:10px; position: relative; 
                input{cursor: pointer;}
                img{max-width: 100%; height: auto; max-height: 100%; margin: 0 auto;}
                span{position: absolute; right: 5px; top:5px;cursor: pointer;
                  &.remove{color: #f00;}
                }
              }
            }
            #list_icon{margin-top: 10px;
              .box-button{width: 122px; float: left;
                .item-button{height: 30px; background: #FAFAFA 0% 0% no-repeat padding-box;box-shadow: 0px 1px 1px #00000029;border: 0.5px solid #E0E0E0;border-radius: 5px; text-align: center; display: block; width: 100%; margin-bottom: 10px; position: relative;
                  input[type='file']{cursor: pointer;}
                  span{color: #343A40; font-size: 13px; display: block;line-height: 30px; cursor: pointer;}
                }
              }
              .box-item-icon{margin:0; width: calc(100% - 140px); float: left;
                span.required{margin-left: 15px;}
              }
            }
          }
          .note{text-align: left;font-size: 15px;color: #343A40;letter-spacing: 0px; font-weight: normal;
            .link{color: #9F6A28;
              .domain{font-weight: normal;}
              .text{color: #9F6A28;}
            }
          }
        }
        .item-pc-bottom{text-align: center;margin-top: 30px;
          button{margin: 0; height: 48px; width: 160px; background: #fff 0% 0% no-repeat padding-box; border-radius: 5px;border: 1px solid #FFD311;color: #23180A; font-size: 14px; display: inline-block;
            &.active{background: #FFD311 0% 0% no-repeat padding-box;margin-right: 30px;}
          }
          a.button{width: 160px; background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #FFD311;border-radius: 5px;color: #23180A; font-size: 14px; display: inline-block; padding: 12.5px 0;}
        }
      }
  }
}
@media (max-width: 1366px){
  
}
@media (max-width: 1024px){
  
}
@media (max-width: 991px){
  
}
@media (max-width: 767px){
  .box-content{
    .box-pc-step{ width: 100% !important;
      .item-pc-title{display: none;}
      .item-pc-img{margin: 20px 0;}
      .item-pc-bottom{
        span{display: initial;}
        // button{width: 100%;}
        // a.button{width: 100%; margin-top: 10px;}
      }
    }
  }
}
@media (max-width: 560px){
  .box_step{text-align: center; margin:  25px auto;
  }
  .box-content{
    .box-pc-create{
      .item-pc-bottom{
        button{width: 100% !important;margin-bottom: 10px !important;}
        a.button{width: 100% !important; }
      }
    }
    .box-pc-step{
      .item-pc-bottom{
        button{width: 100% !important;margin-bottom: 10px !important;}
        a.button{width: 100% !important; }
      }
    } 
  }
}
</style>



// WEBPACK FOOTER //
// step.vue?73d90a7a